module.exports = __webpack_public_path__ + "img/20200707_103608_resized.95888a15.jpg";